module.exports = __webpack_public_path__ + "img/_avatar_placeholder.4880cdf4.svg";